import { createAction } from '@reduxjs/toolkit';

export const setCurrentStep = createAction('StepSmartBirthday/currentStep/set');
export const setBirthday = createAction('StepSmartBirthday/birthday/set');
